@if (levelName && isTitleOnly) {
  <div class="small-label">{{ 't.you-are' | translate }}</div>
  <div class="row">
    <div class="label" [class]="levelName | lowercase">{{ levelName }}
      VIP
    </div>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </div>
} @else if (levelName) {
  <span [class]="levelName | lowercase"> {{ levelName }} VIP </span>
} @else {
  <div class="row">
    <div class="become">{{ 't.become-vip' | translate }}</div>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </div>
}

<ng-template #contentTpl><ng-content></ng-content></ng-template>
